export const nav = {
  root: '',
  routes: {
    root: '',
    workcenter: '/work-center',
    downtimeReason: '/downtime-reason',
    setupParameter: '/setup-parameter',
  }
};
